
define('text!bindingHandlers/accordion2/templates/body.html',[],function () { return '<div class="accordion-body-wrapper">\n    <div class="accordion-body"></div>\n</div>\n';});

